'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { cn } from '@module/lib/utils';
import { DropdownMenuContent } from '@pc/components/ui/dropdown-menu';
import { AfterItem } from './AfterItem';
import { BeforeItem } from './BeforeItem';
function NavMenuList() {
  const $ = _c(7);
  const {
    isLogin
  } = useGetLoginInfoQuery();
  let t0;
  if ($[0] !== isLogin) {
    t0 = cn("modal-scrollbar-custom z-[31] w-[300px] overflow-y-scroll rounded-[16px] p-0 text-left", {
      "max-h-[calc(100vh-70px)]": isLogin
    });
    $[0] = isLogin;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isLogin) {
    t1 = isLogin ? <AfterItem /> : <BeforeItem />;
    $[2] = isLogin;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <DropdownMenuContent align="end" className={t0}>{t1}</DropdownMenuContent>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
export default NavMenuList;